<!-- ── Backdrop mobile ─────────────────────────────────────────────────────── -->
@if (isResponsive() && mobileOpen()) {
  <div
    class="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm"
    (click)="mobileOpen.set(false)"
    aria-hidden="true"
  ></div>
}

<!-- ── Sidebar ─────────────────────────────────────────────────────────────── -->
<aside
  [class]="asideClass()"
  class="bg-sidebar-primary dark:bg-black flex flex-col overflow-hidden transition-all duration-300 ease-in-out dark:border-r"
  (mouseenter)="hovered.set(true)"
  (mouseleave)="hovered.set(false)"
>
  <!-- Header -->
  <div
    class="flex items-center h-16 py-3 gap-2 transition-all duration-300"
    [class]="isCollapsed() ? 'px-3 justify-center' : 'px-6 justify-between'"
  >
    <a
      routerLink="/app/home"
      class="overflow-hidden transition-all duration-300 ease-in-out"
      [class]="isCollapsed() ? 'w-auto pt-4 shrink-0 ' : 'w-auto opacity-100'"
    >
      <img
        [ngSrc]="isCollapsed()?'/assets/images/logo-v-white.png':'/assets/images/logo-h-white.png'"
        alt="Logo"
        width="400"
        height="400"
        priority
        class="w-auto object-left object-contain"
        [class.h-28]="!isCollapsed()"
        [class.h-16]="isCollapsed()"
      />
    </a>

    <button
      (click)="isResponsive() ? mobileOpen.set(false) : toggleCollapsed()"
      class="shrink-0 rounded-md cursor-pointer p-1.5 text-white hover:bg-sidebar-accent hover:text-sidebar-accent-foreground transition-colors"
      [attr.aria-label]="isResponsive() ? 'Fermer le menu' : (collapsed() ? 'Déplier le menu' : 'Réduire le menu')"
      [class.hidden]="isCollapsed()"
    >
      @if (isResponsive()) {
        <app-icon name="x" [size]="18" aria-hidden="true" />
      } @else {
        <app-icon
          [name]="collapsed() ? 'panel-left-open' : 'panel-left-close'"
          [size]="18"
          aria-hidden="true"
        />
      }
    </button>
  </div>

  <!-- Nav -->
  <nav
    class="flex-1 w-full py-4 px-2 flex flex-col gap-2 overflow-y-auto"
    aria-label="Menu principal"
  >
    @for (group of visibleGroups(); track group.label) {
      <div role="group" [attr.aria-label]="group.label" class="group">
        <!-- Accordion header -->
        <div class="relative h-8">
          <button
            type="button"
            (click)="toggleGroup($index)"
            class="w-full flex items-center cursor-pointer px-4 py-2 transition-all duration-200 ease-in-out  rounded-md"
            [attr.aria-expanded]="isGroupOpen($index)"
          >
            <span
              class="text-xs font-semibold uppercase tracking-wider text-white overflow-hidden whitespace-nowrap transition-all duration-300 ease-in-out"
              [class]="isCollapsed() ? 'sr-only' : 'block'"
            >
              {{ group.label }}
            </span>

            <div class="ml-auto flex items-center gap-2">
              <div class="flex items-center justify-center" [class]="isCollapsed() ? 'opacity-100' : 'opacity-0'">
                <app-icon
                  [name]="group.icon ?? moreIcon"
                  [size]="14"
                  class="text-white"
                  aria-hidden="true"
                />
              </div>

              <app-icon
                name="chevron-down"
                [size]="14"
                [class]="chevronClass($index) + ' text-white'"
                aria-hidden="true"
              />
            </div>
          </button>
        </div>

        <!-- Items: only rendered/visible when group is open (accordion) -->
        <ul
          class="flex flex-col gap-0.5 overflow-hidden transition-[max-height,opacity] duration-200 ease-in-out border-l ml-6"
          [style.max-height.px]="isGroupOpen($index) ? group.items.length * 44 : 0"
          [style.opacity]="isGroupOpen($index) ? 1 : 0"
          [attr.aria-hidden]="!isGroupOpen($index)"
        >
          @for (item of group.items; track item.label) {
            <li
              [class.hidden]="item.hidden"
              class="ml-2"
            >
              <a
                [routerLink]="item.href"
                routerLinkActive="bg-sidebar-accent dark:bg-white text-sidebar-primary! font-semibold"
                [title]="isCollapsed() ? item.label : ''"
                [class.opacity-0]="isCollapsed()"
                class="flex w-full items-center rounded-md px-3 py-2 text-sm font-medium text-white transition-colors hover:dark:bg-white hover:bg-sidebar-accent hover:text-sidebar-primary!"
                [class]="isCollapsed() ? 'justify-center' : 'gap-3'"
              >
                @if (item.icon) {
                  <app-icon
                    [name]="item.icon"
                    [size]="18"
                    aria-hidden="true"
                    class="shrink-0"
                  />
                }
                <span
                  class="overflow-hidden whitespace-nowrap transition-all duration-300 ease-in-out"
                  [class]="isCollapsed() ? 'w-0 opacity-0' : 'flex-1 opacity-100'"
                >
                  {{ item.label }}
                </span>
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </nav>
</aside>
